module.exports = __webpack_public_path__ + "static/media/Utiliserlaplateforme4Loutilcomptable.274eb071.pdf";